<div class="row">
  <div class="d-flex flex-column flex-md-row align-items-center justify-content-between">
    <div>
      <h2 class="page-title">Countries</h2>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a routerlink="." href="/">Home</a>
          </li>
          <li aria-current="page" class="breadcrumb-item active">Countries</li>
        </ol>
      </nav>
    </div>
    <button *ngIf="masterService.checkFeatureBoolean('MASTER.COUNTRY.CREATE')" type="button" (click)="addCountry()" class="btn btn-primary btn-icon-text"><i class="feather icon-plus btn-icon"></i> Add Country </button>
  </div>
</div>

<div class="grid-margin stretch-card">
  <div class="card">
    <div class="card-body">
      <div class="clearfix mb-2">
        <div class="float-start">
          <div class="input-group search-component">
            <input
              type="text"
              class="form-control"
              placeholder="Search"
              aria-label="Search"
              [(ngModel)]="element.searchKey"
              name="element"
            />
            <button type="button" (click)="clearSearch()" class="btn btn-outline-secondary btn-icon">
              <i class="feather icon-x"></i>
            </button>
            <button appBusy type="button" (click)="searchKey()" class="btn btn-outline-primary btn-icon-text">
              <i class="feather icon-search btn-icon-prepend"></i> Search
            </button>
          </div>
        </div>
        <br>
      </div>
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Country Name</th>
              <th>Country Code</th>
              <th>Date Created</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let country of countryList; let row = index">
              <td>{{row + 1}}</td>
              <td>{{country?.countryName}}</td>
              <td>{{country?.countryCode}}</td>
              <td>{{country?.createdDate | date: 'dd-MM-yyyy HH:mm'}}</td>
              <td>
                <button *ngIf="masterService.checkFeatureBoolean('MASTER.COUNTRY.MODIFY')" type="button" (click)="editCountry(row)" title="Edit" class="btn btn-xs btn-icon">
                  <i class="feather icon-edit-2"></i>
                </button>
                <button *ngIf="masterService.checkFeatureBoolean('MASTER.COUNTRY.DELETE')" type="button" (click)="deleteCountry(row)" title="Delete" class="btn btn-xs btn-icon text-danger">
                  <i class="feather icon-trash-2"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination Controls -->
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div>
            <select class="form-select form-select-sm" [(ngModel)]="element.size" (change)="onPageChange({pageIndex: 0, pageSize: element.size})">
              <option *ngFor="let size of pageSizeOptions" [value]="size">{{size}} items per page</option>
            </select>
          </div>

          <div>
            Showing {{ (element.page * element.size) + 1 }} - 
            {{ Math.min((element.page + 1) * element.size, totalElements) }} 
            of {{ totalElements }} items
          </div>

          <div>
            <button
              class="btn btn-link"
              [disabled]="element.page === 0"
              (click)="onPageChange({pageIndex: element.page - 1, pageSize: element.size})"
            >
              <i class="feather icon-chevron-left"></i>
            </button>

            <button
              class="btn btn-link"
              [disabled]="element.page >= totalPages - 1"
              (click)="onPageChange({pageIndex: element.page + 1, pageSize: element.size})"
            >
              <i class="feather icon-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<simple-notifications [options]="notificationOptions"></simple-notifications>
